import { render } from "./InvoiceReviewList.vue?vue&type=template&id=6474da68"
import script from "./InvoiceReviewList.vue?vue&type=script&lang=js"
export * from "./InvoiceReviewList.vue?vue&type=script&lang=js"

import "./InvoiceReviewList.vue?vue&type=style&index=0&id=6474da68&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__